import { Deserializable } from '../protocols/deserializable';
import { Mentionable } from '../base/mentionable';

interface ProfileBadgeConfiguration {
  id: number;
  name: string;
  backgroundColour: string;
  borderColour: string;
}

interface RetirementStubHistoryCreatedBy {
  id: number;
  firstName: string;
  lastName: string;
  profileBadgeConfiguration: ProfileBadgeConfiguration | null;
}

export class MemberRetirementStubHistory implements Deserializable {
  public id!: number;
  public retirementStubId!: number;
  public description!: string;
  public comment?: string | null;
  public memberSubmissionId?: number | null;
  public createdById!: number;
  public createdBy!: RetirementStubHistoryCreatedBy;
  public createdDate!: string;
  public author!: Mentionable;

  public onDeserialize(): void {
    this.author = window?.injector?.Deserialize?.instanceOf(Mentionable, {
      id: this.createdBy?.id,
      firstName: this.createdBy?.firstName,
      lastName: this.createdBy?.lastName,
      profileColour: this.createdBy?.profileBadgeConfiguration?.backgroundColour ?? ''
    });
  }
}
